// Mixins
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"

// Components
const MemberTableComponent = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "member-table-component"*/ "@/app/views/main-view/social-club/components/member-table-component/member-table-component.vue"
	)

// Services
import ClubService from "@/app/services/main/club/club-service.js"

// Third Party libraries
import * as $ from "jquery"

// Constants
import { STATUS_CODES, USER_CLUB_STATUS } from "@/app/constants/status-constants"

export default {
	name: "myGroupSearchModal",
	components: {
		MemberTableComponent,
	},
	mixins: [toastMessageMixins, tableMixins],
	data() {
		return {
			isAPILoading: false,
			searchMember: "",
			isGetGroupsLoading: false,
			tabs: [
				{
					id: "myGroups",
					label: "My Groups",
					active: true,
					memberStatusFilter: "ACTIVE",
				},
				{
					id: "searchGroups",
					label: "Group Search",
					active: false,
					memberStatusFilter: "INACTIVE",
				},
				{
					id: "pendingRequest",
					label: "Pending Requests",
					active: false,
					memberStatusFilter: "PENDING",
				},
			],
		}
	},
	computed: {
		getActiveTab() {
			return this.tabs.find((tab) => tab.active)
		},
		groupAdminRequests() {
			return this.$store.getters.getGroupAdminRequests
		},
	},
	beforeDestroy() {
		this.closeModal()
	},
	methods: {
		openModal() {
			$(this.$refs.myGroupSearchModal).modal("show")
			this.columnsFilter = {}
			this.searchMember = ""
			this.setActiveTab(this.tabs[0].id)
		},
		closeModal() {
			$(this.$refs.myGroupSearchModal).modal("hide")
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
			page = fromFilter ? 1 : this.page

			this.getGroupLists({ page: this.page, limit: this.limit, sortBy: this.sortBy, desc: this.desc })
		},
		getGroupLists(queryParams) {
			this.isGetGroupsLoading = true

			queryParams["f_memberStatus"] = this.getActiveTab.memberStatusFilter

			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}
			}

			// change this to the specific endpoint
			ClubService.getGroups(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						this.showCustomErrorToast(res.data.errors[0].message, null, true)
					}
					this.isGetGroupsLoading = false
				})
				.catch(() => {
					this.isGetGroupsLoading = false
					this.showGenericErrorToast()
				})
		},
		setActiveGroup(group) {
			if (this.getActiveTab.id === this.tabs[0].id) {
				this.$store.commit("setActiveGroup", group)

				this.closeModal()
			}
		},
		joinGroup(group) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/success-dog.png")}`,
				imageAlt: "Success Dog",
				titleText: `Request To Join In - ${group.name} Group`,
				html: `<p>Are you sure you want to request to be part of the ${group.name} Group? <br>You will be able to see all the posts and comments inside the group.</p>`,
				confirmButtonText: "Send Request",
				cancelButtonText: "Cancel",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					// Call request to join in group API endpoint
					ClubService.requestToJoinInGroup(group.id).then((res) => {
						const { ERROR_REQUEST_TO_JOIN_GROUP, SUCCESS_REQUEST_TO_JOIN_GROUP } =
							this.toastMessages.club(group)
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(SUCCESS_REQUEST_TO_JOIN_GROUP)

							this.getTableContent()
						} else {
							this.showAPIErrorToast(ERROR_REQUEST_TO_JOIN_GROUP, res)
						}
					})
				}
			})
		},
		cancelJoinGroupRequest(group) {
			this.$swal({
				imageHeight: "30px",
				imageUrl: `${require("@/assets/images/_shared/dog-confirm.png")}`,
				imageAlt: "Dog Confirm",
				titleText: `Cancel Join Request - ${group.name} Group`,
				html: `<p>Are you sure you want to cancel your request to be part of the ${group.name} Group?`,
				confirmButtonText: "Send Cancel Request",
				cancelButtonText: "Cancel",
				customClass: {
					header: "header-social-club",
					title: "title-social-club",
				},
				showCancelButton: true,
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					const reqBody = {
						customerIds: [this.$store.getters.getUserDetails.id],
						status: USER_CLUB_STATUS.INACTIVE,
					}

					// Call request to cancel join in group API endpoint
					ClubService.updateGroupMemberStatus(group.id, reqBody).then((res) => {
						const { ERROR_REQUEST_TO_JOIN_GROUP, SUCCESS_REQUEST_TO_CANCEL_JOIN_GROUP } =
							this.toastMessages.club(group)
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast(SUCCESS_REQUEST_TO_CANCEL_JOIN_GROUP)

							this.getTableContent()
						} else {
							this.showAPIErrorToast(ERROR_REQUEST_TO_JOIN_GROUP, res)
						}
					})
				}
			})
		},
		setActiveTab(selectedTab) {
			this.page = 1
			this.tabs = this.tabs.map((tab) => {
				// set the selected tab to active
				tab.active = tab.id === selectedTab

				return tab
			})

			this.getTableContent()
		},
		checkPendingCount(groupId) {
			const findGroupPendingReports = this.groupAdminRequests.pendingReports.find(
				(pendingReport) => pendingReport.groupId == groupId
			)
			const findAdminRequest = this.groupAdminRequests.adminRequests.find(
				(adminRequest) => adminRequest.groupId === groupId && adminRequest.access === "CC"
			)
			const findMemberRequest = this.groupAdminRequests.memberRequests.find(
				(memberRequest) => memberRequest.groupId === groupId
			)

			return (findGroupPendingReports && findGroupPendingReports.pendingReportsCount > 0) ||
				(findAdminRequest && findAdminRequest.adminRequestCount > 0) ||
				(findMemberRequest && findMemberRequest.memberRequestCount > 0)
				? true
				: false
		},
	},
}
